import { Core } from "../../components/infrastructure/core";
import { Button, Form } from "antd";
import { StopOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { IPaymentProps, IPaymentStates } from "./interfaces";
import { useEffect, useState } from "react";
import { DatePicker as DatePickerJalali } from "antd-jalali";
import { AttachmentUploader } from "../../baseInfo/attachment/attachmentUploader";
import { IAttachment } from "../../baseInfo/attachment/interfaces";
import { AttachmentViewer } from "../../baseInfo/attachment/attachmentViewer";

type LayoutType = Parameters<typeof Form>[0]['layout'];

export const Payment = (props: IPaymentProps) => {

    const [state, setState] = useState<IPaymentStates>({ loading: false, entity: props.entity ?? { PaymentReceipts: [] } as any });
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: { xxl: 6, xl: 6, lg: 8, md: 8, sm: 10, xs: 24 },
        wrapperCol: { xxl: 12, xl: 12, lg: 16, md: 16, sm: 14, xs: 24 }
    };

    const [formLayout] = useState<LayoutType>('horizontal');

    useEffect(() => {

    }, []);

    const submit = async () => {
        const { entity } = state;
        if (!entity)
            return;

        setState({ ...state, loading: true });
        const data = new FormData();
        data.append('Payment', JSON.stringify({
            RepairCaseId: props.repairCase.Id,
            RowVrsn: props.repairCase.RowVrsn,
            ReceiptDateTime: state.entity.PaymentReceiptDateTime
        }));

        state.entity.PaymentReceipts.forEach((r: any) => {
            data.append('ReceiptDescriptions', r['Description']);
            data.append('Receipts', r['File']);
        });

        if (props.onSubmit)
            await props.onSubmit({
                data,
                url: "repaircasecenter/payment",
                contentType: false,
                headers: [{ key: "encType", value: "multipart/form-data" }],
                completeCallback: result => {
                    setState({ ...state, loading: false });
                    if (result.ValidationState.Successful) {
                        Core.successNotification('دریافت مبلغ تعمیرات انجام شد');
                        props.onClose && props.onClose({});
                    }
                }
            });
    };

    const onChangePaymentReceiptDateTime = (e: any) => {
        const { entity } = state;
        if (e) {
            let parsedDate = e.toDate();
            parsedDate = new Date(parsedDate.toDateString());
            const newEntity = { ...entity, PaymentReceiptDateTime: parsedDate.toDateString() };
            setState({ ...state, entity: newEntity });
        }
        else {
            const newEntity = { ...entity, PaymentReceiptDateTime: undefined };
            setState({ ...state, entity: newEntity });
        }
    }

    const onChangePaymentReceipts = (attachments: IAttachment[]) => {
        const { entity } = state;
        const newEntity = { ...entity, PaymentReceipts: attachments };
        setState({ ...state, entity: newEntity });
    }

    const { PaymentReceiptDateTime, PaymentReceipts } = state.entity;
    return (
        <Form
            form={form}
            scrollToFirstError
            {...formItemLayout}
            layout={formLayout}
            onFinish={submit}
            onReset={() => {
                props.onClose && props.onClose(this);
            }}
            style={{ padding: 0 }}
            
        >
            <Form.Item
                label={'تاریخ واریز'}
                name={'PaymentReceiptDateTime'}
                key={'PaymentReceiptDateTime'}
                initialValue={PaymentReceiptDateTime}
            >
                <DatePickerJalali
                    onChange={onChangePaymentReceiptDateTime}
                    format="YYYY/MM/DD"
                    style={{ display: 'block' }}
                    disabled={props.disabled}
                />
            </Form.Item>
            <Form.Item
                label={'تصویر واریز'}
                name={'PaymentReceipts'}
                key={'PaymentReceipts'}
                style={{ width: "100%" }}
            >
                {props.disabled ?
                    <AttachmentViewer attachments={PaymentReceipts.filter(a => !!a.Tag)} />
                    :
                    <AttachmentUploader
                        whiteList='image/png,image/jpg,image/jpeg,application/pdf'
                        attachments={PaymentReceipts}
                        onChange={onChangePaymentReceipts}
                        disabled={false} />
                }
            </Form.Item>
            {props.disabled === true ? <></> :
                <Form.Item wrapperCol={{ dir: 'ltr' }} style={{ zIndex: 1000, borderTop: '1px solid', borderColor: '#e5e5e5', marginTop: 10 }}>
                    <Button type="primary" htmlType="submit" icon={<CheckCircleOutlined />} loading={state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10 }}>
                        ثبت
                    </Button>

                    <Button type="ghost" htmlType="reset" icon={<StopOutlined />} loading={state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                        لغو
                    </Button>
                </Form.Item>
            }
        </Form>
    );
}